import { useMutation } from 'react-query';
import { MutationConfig, queryClient } from 'src/lib/react-query';
import useNotification from 'src/store/Notifications/useNotification';
import { axiosDefaultApi } from 'src/lib/axios';


const editModelType = ( {data, modelTypeId} : {data: IPostEditModelType | {}, modelTypeId: number}): Promise<string> => {
  return axiosDefaultApi.put(`/api/ModelTypes/UpdateModelType/${modelTypeId}`, data);
};

type QueryFnType = typeof editModelType;

type UseEditModelTypeOptions = {
  data: IPostEditModelType | {};
  modelTypeId: number;
  config?: MutationConfig<QueryFnType>;
};

export const useEditModelType = ({ config }: UseEditModelTypeOptions) => { 
    const {addNotification, setIsNotificationVisible} = useNotification();
    return useMutation({
        onError: (error: any) => {
            addNotification(`Υπήρξε κάποιο πρόβλημα στην επεξεργασία του Είδους Συσκευής.`, 500);
            console.error('Couldnt edit ModelType', error);
            setIsNotificationVisible(true)
          },
          onSuccess: () => {
            queryClient.invalidateQueries(["getAllModelTypes"])
            addNotification('Το Είδος Συσκευής Ενημερώθηκε.', 200);
            setIsNotificationVisible(true)
          },
        ...config,
        mutationFn: editModelType,
    })
}